import { Component, Input } from '@angular/core';

@Component({
    selector: 'itpx-pagetemplate',
    templateUrl: './pagetemplate.component.html',
    styleUrls: [ './pagetemplate.component.css' ]
})
export class PageTemplateComponent  {
    @Input() status: string;
    @Input() errorMessage: string;
    @Input() errorTitle: string;

    constructor(
    ) {}

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/core/components/partials/pagetemplate/pagetemplate.component.ts